import React, { useRef, useMemo } from 'react';
import { useFrame, extend } from '@react-three/fiber';
import * as THREE from 'three';
import { Line2 } from 'three/examples/jsm/lines/Line2';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial';
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry';

extend({ Line2, LineMaterial, LineGeometry });

const AnimatedEllipse: React.FC = () => {
    const ref = useRef<any>();
    const ellipse = useMemo(() =>
        new THREE.EllipseCurve(0, 0, 5, 3, 0, Math.PI * 2, false, 0), []);

    const initial = useMemo(() =>
        ellipse.getPoints(128).flatMap(p => [p.x, p.y, 0]), [ellipse]);

    useFrame(({ clock, size }) => {
        const t = clock.getElapsedTime();
        ellipse.xRadius = 5 + Math.sin(t * 0.5) * 1.5;
        ellipse.yRadius = 3 + Math.cos(t * 0.7);
        const pts = ellipse.getPoints(128).flatMap(p => [p.x, p.y, 0]);

        if (ref.current) {
            ref.current.geometry.setPositions(pts);
            ref.current.material.resolution.set(size.width, size.height);
        }
    });

    return (
        <line2 ref={ref}>
            <lineGeometry attach="geometry" positions={initial} />
            <lineMaterial attach="material" color={0xffaa00} linewidth={4} />
        </line2>
    );
};

export default AnimatedEllipse;